import React from 'react';
import MarkingTemplateIcon from '../../../static/img/Black-rubric.svg';
import { SelectableFeedbackType } from './shared/SelectableFeedbackType';

export const MarkingTemplatesFeedbackType = ({
  formData,
  updateFormData,
  allMarkingCriterias = [],
  onMarkingCriteriaPreview,
  showLabel = true,
  showTooltip = true,
  filterSubject = null,
  compactTriggerLabel = null,
  placeholder = null,
  hideGoToLink = false,
}) => {
  const getSelectedItem = () => {
    return formData.markingCriteria;
  };

  const handleSelect = (markingCriteria) => {
    updateFormData({
      markingCriteria: markingCriteria,
    });
  };

  const handleDelete = () => {
    updateFormData({ markingCriteria: null });
  };

  const handlePreview = () => {
    if (formData.markingCriteria && onMarkingCriteriaPreview) {
      onMarkingCriteriaPreview(formData.markingCriteria);
    }
  };

  const selectedItem = getSelectedItem();
  const selectedItemId = selectedItem?.id;
  const rubricsOnly = allMarkingCriterias.filter(item => 
    !item.id || item.id === 'no_marking_criteria' || item.type === 'RUBRICS' || item.id === selectedItemId
  );

  return (
    <SelectableFeedbackType
      key={`marking-template-${selectedItemId || 'none'}`}
      formData={formData}
      updateFormData={updateFormData}
      allItems={rubricsOnly}
      onPreview={handlePreview}
      icon={MarkingTemplateIcon}
      label="Rubrics"
      tooltipText="Learn more about Rubrics"
      selectedItem={selectedItem}
      getSelectedItem={getSelectedItem}
      onSelect={handleSelect}
      onDelete={handleDelete}
      goToRoute="/tools/rubrics"
      popupItemType="Marking Template"
      hideTypeFilter={true}
      showLabel={showLabel}
      showTooltip={showTooltip}
      filterSubject={filterSubject}
      compactTriggerLabel={compactTriggerLabel}
      placeholder={placeholder}
      hideGoToLink={hideGoToLink}
    />
  );
};
